module.exports = __webpack_public_path__ + "img/plant-analytics.b56428af.svg";